import { ACTIVE_COMPANY_CONFIG } from './company-config';

export class ConstantsProviders {

  // public static PROTOCOL = 'http://';
  // public static PORT_WSHTTP = ':80';
  public static PROTOCOLHTTPS = ACTIVE_COMPANY_CONFIG.protocolHttps;
  public static PORT_WSHTTPS = ACTIVE_COMPANY_CONFIG.portWsHttps;

  public static SERVER_URL = ACTIVE_COMPANY_CONFIG.serverUrl;

  public static SERVER_WS: string = ConstantsProviders.PROTOCOLHTTPS
    + ConstantsProviders.SERVER_URL + ConstantsProviders.PORT_WSHTTPS;
  // public static SERVER_WS: string = ConstantsProviders.PROTOCOL
  // + ConstantsProviders.SERVER_URL + ConstantsProviders.PORT_WSHTTP;
  public static APPGATEWAY = '/gotaxi-gateway-web/webresources/';

  public static URIFOTOCHOFER = 'https://www.fleet.uy/fotoschoferes/';
  public static COMPANY_RUT = ACTIVE_COMPANY_CONFIG.companyRut;
  public static FOLDERRUTFOTOCHOFER = ACTIVE_COMPANY_CONFIG.folderRutFotoChofer;
  public static EXTFILECHOFER = '.jpg';

  // WS Gateway
  public static BASEWS = 'clientwebfleet/';
  public static WSGETCLIENT = ConstantsProviders.BASEWS + 'getClient/';
  public static WSGETSERVICESMONITOR = ConstantsProviders.BASEWS + 'getallservicesmonitor/';
  public static WSGETALLVEHICLE = ConstantsProviders.BASEWS + 'getfleet';
  public static WSGETALLVEHICLEONLINE = ConstantsProviders.BASEWS + 'getVehicleOnLine';
  public static WSNEWSERVICE = ConstantsProviders.BASEWS + 'putservice/';
  public static WSSENDMESSAGE = ConstantsProviders.BASEWS + 'sendMsg/';
  public static WSGLOBAL = ConstantsProviders.BASEWS + 'getglobal/';
  public static WSCANCELSERVICE = ConstantsProviders.BASEWS + 'cancel_service/';
  public static WSTYPEPAY = 'gestion/getAllTypePayment/'; // es el ws en despacho relacionado a la admin
  public static WSSTATISTICS = ConstantsProviders.BASEWS + 'getglobalestatistics/';
  public static WSSEARCHSERVICEHIST = ConstantsProviders.BASEWS + 'getservicehistory/';
  public static WSSEARCHSCHEDULED = ConstantsProviders.BASEWS + 'getsearchscheduled/';
  public static WSLISTVEHICLEONLINESTATUS = ConstantsProviders.BASEWS + 'getListVehicleStatusOnLine/';
  public static WSGETVEHICLESFORASSIGN = ConstantsProviders.BASEWS + 'getVehiclesForAssign/';
  public static WSPUTASSINGVEHICLE = ConstantsProviders.BASEWS + 'putassingvehicle/';
  public static WSPUTASSIGNNEXTSERVICE = ConstantsProviders.BASEWS + 'putassignnextservice/';
  public static WSAUTHUSER = ConstantsProviders.BASEWS + 'logingxadmin/';
  public static WSLASTPOST = ConstantsProviders.BASEWS + 'getlastposvehicle/';
  public static WSLOGOUTDRIVER = ConstantsProviders.BASEWS + 'logoutdrivervehi/';
  public static WSLISTDRIVERS = ConstantsProviders.BASEWS + 'getdrivers/';
  public static WSRESCHEDULER = ConstantsProviders.BASEWS + 'rescheduleservice/';
  public static WSHOLD = ConstantsProviders.BASEWS + 'holdeservice/';
  public static WSGETALLUSER = 'getalluser/';
  public static WSGETTRAKING = ConstantsProviders.BASEWS + 'trackingvehicle/';
  public static WSGETTRAKINGSERVICE = ConstantsProviders.BASEWS + 'trackingservice/';

  // Zonas geográficas — descomentar cuando el backend esté listo
  // public static WSGETALLZONES = ConstantsProviders.BASEWS + 'getallzones/';
  // public static WSGETZONE     = ConstantsProviders.BASEWS + 'getzone/';
  // public static WSSAVEZONE    = ConstantsProviders.BASEWS + 'savezone/';
  // public static WSUPDATEZONE  = ConstantsProviders.BASEWS + 'updatezone/';
  // public static WSDELETEZONE  = ConstantsProviders.BASEWS + 'deletezone/';

  public static WSCHANGEPASSWORD = 'changepassword/';
  public static WSGETPROFILE = 'getprofile/';


  public static urlMapQuest = 'https://www.mapquestapi.com/geocoding/v1/address?key=';

  // PubNub
  public static publishkey = ACTIVE_COMPANY_CONFIG.pubNubPublishKey;
  public static subscribekey = ACTIVE_COMPANY_CONFIG.pubNubSubscribeKey;
  public static secretkey = ACTIVE_COMPANY_CONFIG.pubNubSecretKey;

  public static ZOOMDEFAULT = 16;

  // URL para solicitar el monto de la tarifa
  public static URIFAREAPI = "/fleet-ms-web-gateway/apiv2/"
  public static URL_FLEET_WSAPIV2 = ConstantsProviders.SERVER_WS + ConstantsProviders.URIFAREAPI // prod

  public static WSCALCULATEFARE = "calculate"
  public static WSCALCULATEFAREONLY = "calculateonly"
  public static WSCURRENTFARE = "current/"
  public static WSUPDATEFARE = "update"
  public static WSHOLIDAYSGETALL = "holidays/getall"


  public static AppRoleDisplay = ACTIVE_COMPANY_CONFIG.appRoleName;
  public static AppNameDisplay = ACTIVE_COMPANY_CONFIG.companyName;
  public static APP_DISPLAY_NAME = ConstantsProviders.AppRoleDisplay + ' ' + ConstantsProviders.AppNameDisplay;
  public static AppLogoDisplay = ACTIVE_COMPANY_CONFIG.appLogoDisplay;
  public static AppPoiCompany = ACTIVE_COMPANY_CONFIG.appPoiCompany;

  public static myKeyMapQuest = ACTIVE_COMPANY_CONFIG.mapQuestKey;

  public static LATDEFAULT = ACTIVE_COMPANY_CONFIG.latDefault;
  public static LNGDEFAULT = ACTIVE_COMPANY_CONFIG.lngDefault;

  public static LATADDRESSDEFAULT = ACTIVE_COMPANY_CONFIG.latAddressDefault;
  public static LNGADDRESSDEFAULT = ACTIVE_COMPANY_CONFIG.lngAddressDefault;

  public static ENABLE_FARE = ACTIVE_COMPANY_CONFIG.enableFare;
  public static ENABLE_ZONES = ACTIVE_COMPANY_CONFIG.enableZones;

  public static AppVersion: string = 'V.1.0.6.2'
}
